import { createSlice } from "@reduxjs/toolkit";
import projectsData from "../../data/projects-api.json";

const projectsSlice = createSlice({
  name: "projects",
  initialState: {
    list: projectsData,
    visibleCount: 9,
  },
  reducers: {
    loadMore(state) {
      state.visibleCount += 9;
    },
    resetVisibleCount(state) {
      state.visibleCount = 9;
    },
  },
});

export const { loadMore, resetVisibleCount } = projectsSlice.actions;

export default projectsSlice.reducer;

export const selectProjects = (state) => state.projects.list;
export const selectVisibleCount = (state) => state.projects.visibleCount;
